import {Tooltip} from "antd";

export const TIMESHEET_TYPE_OPTIONS = [
    {value: 'Productive Day', label: 'Productive Day'},
    {value: 'Half Day',       label: 'Half Day'},
    {value: 'Week Off',       label: 'Week Off'},
    {value: 'Holiday',        label: 'Holiday'},
    {value: 'Leave',          label: 'Leave'},
];

export const TASK_STATUS_OPTIONS = [
    {value: 'all',      label: 'All'},
    {value: 'pending',  label: 'Pending'},
    {value: 'approved', label: 'Approved'},
];

export const REPORT_TYPE_OPTIONS = [
    {value: 'user',    label: 'User Report'},
    {value: 'project', label: 'Project Report'},
    {value: 'leave',   label: 'Leave Report'},
];

export const USER_ROLE_OPTIONS = [
    {value: 'manager',         label: 'Manager'},
    {value: 'external manager', label: 'External Manager'},
    {value: 'user',            label: 'User'},
];

export const ACCESS_OPTIONS = [
    {value: 'Required',     label: 'Required'},
    {value: 'Not Required', label: 'Not Required'},
];

export const approvalBaseColumns = [
    {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: 110,
    },
    {
        title: "Day",
        dataIndex: "day",
        key: "day",
        width: 80,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: "User",
        dataIndex: "user_id",
        key: "user_id",
        width: 100,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    }
];

export const dashboardColumns = [
    {
        title: 'Full Name',
        dataIndex: 'full_name',
        key: 'full_name',
        width: 80,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: 'Email ID',
        dataIndex: 'email',
        key: 'email',
        width: 120,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: 'Mobile No.',
        dataIndex: 'mobile_number',
        key: 'mobile_number',
        width: 80,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: 'Company Name',
        dataIndex: 'company_name',
        key: 'company_name',
        width: 80,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
];

export const dataEntryBaseColumns = [
    {
        title: "Type",
        dataIndex: "type",
        key: "type",
        width: 80,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: "Task",
        dataIndex: "task",
        key: "task",
        width: 100,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: "Task Summary",
        dataIndex: "summary",
        key: "summary",
        width: 120,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
]

export const excelReportColumns = [
    {
        title: "Type",
        dataIndex: "Type",
        key: "Type",
        width: 100,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: "Task",
        dataIndex: "Task",
        key: "Task",
        width: 100,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    },
    {
        title: "Task Summary",
        dataIndex: "Task Summary",
        key: "Task Summary",
        width: 120,
        ellipsis: {showTitle: false},
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ),
    }
];